import MarkdownIt from 'markdown-it'

const markdown = new MarkdownIt({
  breaks: true,
  html: false,
  linkify: true,
})

/** Converts untrusted assistant Markdown into HTML with raw HTML escaped. */
export function renderAssistantMarkdown(source: string): string {
  return markdown.render(source)
}
